import { render, staticRenderFns } from "./MsgAnalysisTransfer_accounts_d.vue?vue&type=template&id=bad6514a&"
import script from "./MsgAnalysisTransfer_accounts_d.vue?vue&type=script&lang=js&"
export * from "./MsgAnalysisTransfer_accounts_d.vue?vue&type=script&lang=js&"
import style0 from "./MsgAnalysisTransfer_accounts_d.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports